/**
 * Textos da conferência da leitura (E140.F3, GUS-143, ADR-0096 §2.7): a falha técnica localizada que
 * a equipe resolve, os pontos do perito e o que está no papel. A falha interna da leitura não vira
 * falta de prova nem pedido ao cliente. E147.F3: as etapas saíram para a conferência das etapas
 * (`pt-BR.etapas.ts`), lidas do servidor.
 */
export const ptBRConferencia = {
  titulo: 'Conferência da leitura',
  carregando: 'Carregando a conferência da leitura…',
  vazio: 'A conferência da leitura aparece aqui depois do exame do caso.',
  erro: 'Não foi possível carregar a conferência da leitura. Tente novamente.',
  semPermissao: 'A conferência da leitura é da equipe que atende o caso.',
  tentarDeNovo: 'Tentar de novo',
  versao: 'Conferida em {quando} (versão {versao}, leitura {ficha}).',
  resumo: {
    aprovada: 'Leitura conferida · pronta para a análise',
    corrigir: 'Leitura em recuperação · documento emitido aguardando',
    bloqueada: 'Pendência técnica · documento emitido travado',
    naoVigente: 'A leitura mudou desde a última conferência · verifique o caso de novo',
  },
  resumoTexto: {
    aprovada: 'Nenhuma falha técnica aberta. Os pontos que pedem o olhar do perito estão abaixo.',
    corrigir:
      'O sistema está lendo de novo as páginas com falha. A conferência se atualiza sozinha quando a leitura terminar.',
    bloqueada:
      'Há falha técnica que o sistema não recupera sozinho. Resolva cada uma abaixo: tente a leitura de novo ou registre a limitação.',
    naoVigente:
      'O documento emitido fica travado até a nova conferência, que sai com a próxima verificação do caso.',
  },
  falhasTitulo: 'Resolver a pendência localizada',
  falhasTexto:
    'O arquivo recebido continua preservado. Responsável: equipe técnica. Não peça ao banco o reenvio de arquivo já recebido por falha da leitura.',
  pendencia: {
    pagina_omitida: 'A página está no arquivo recebido e a leitura não a trouxe.',
    pagina_sem_documento: 'A página do arquivo recebido não caiu em nenhum documento.',
    pagina_por_ler: 'A página em imagem ainda espera a leitura.',
    pagina_com_falha: 'A leitura da página falhou.',
    pagina_sem_texto: 'A página é imagem e nenhuma linha foi lida dela.',
    arquivo_sem_contagem: 'O arquivo recebido não abriu para a conferência das páginas.',
    documento_sem_leitura: 'O documento não foi lido.',
    campo_essencial_sem_leitura: 'Informação essencial em página ou documento que não foi lido.',
    campo_essencial_a_conferir:
      'Informação essencial não localizada pela leitura: confira na fonte antes de afirmar a ausência.',
    campo_essencial_sem_trecho: 'O valor usado no exame não foi achado impresso: confira na fonte.',
    campo_no_papel_sem_uso: 'O documento traz o valor e o exame não o usa.',
    divergencia_essencial: 'As fontes trazem valores diferentes.',
  },
  /**
   * E221.F2: o campo essencial sem página nem documento a reler (o papel não traz a informação; na
   * POC, o Manifesto sem a data em "Contratado em") não diz "página não lida".
   */
  pendenciaSemLugar:
    'A leitura não achou esta informação e não há página por ler: confira no documento e, se ela não estiver impressa, registre a limitação.',
  ondePagina: '{arquivo} · página {pagina}',
  ondeArquivo: '{arquivo}',
  ondeCampo: '{campo}',
  tentativas: '{n} tentativa(s) de leitura até agora.',
  emRecuperacao: 'O sistema vai ler de novo.',
  aguardaEquipe: 'O sistema não recupera esta falha sozinho.',
  verNaFonte: 'Ver na fonte',
  lerDeNovo: 'Tentar a leitura de novo',
  registrarLimitacao: 'Registrar limitação',
  justificativaRotulo: 'Por que a falha é um limite do material',
  justificativaAjuda: 'Mínimo de {n} caracteres. A justificativa fica no histórico do caso.',
  salvarLimitacao: 'Salvar limitação',
  cancelar: 'Cancelar',
  enviando: 'Enviando…',
  pedidoFeito: {
    tentativa: 'Leitura pedida de novo. A conferência se atualiza quando ela terminar.',
    limitacao: 'Limitação registrada.',
  },
  recusa: {
    sem_retomada: 'Ler de novo daria o mesmo resultado: registre a limitação.',
    nao_vigente: 'A leitura mudou: verifique o caso de novo antes.',
    sem_falha_tecnica: 'Esta pendência já foi resolvida.',
    nao_encontrada: 'A pendência não está mais na conferência. Atualize a página.',
    justificativa: 'Escreva a justificativa com pelo menos {n} caracteres.',
    indisponivel: 'Não foi possível registrar agora. Tente novamente.',
  },
  peritoTitulo: 'Pontos para o perito ({n})',
  peritoTexto:
    'Não travam o documento emitido. A ausência no documento só o perito afirma, depois de conferir a fonte.',
  limitacoesTitulo: 'Limitações registradas ({n})',
  limitacao: 'Justificativa: {texto}',
  achadosTitulo: 'O que está no papel ({n})',
  achadosTexto:
    'Campo de formulário não preenchido e campo em branco, como impressos. Não declaram invalidade.',
  achado: {
    marcadorNaoPreenchido: 'Campo de formulário não preenchido',
    campoEmBranco: 'Campo em branco',
  },
  achadoMarca: '“{marca}” em {onde}',
  semPontos: 'Nenhum ponto para o perito.',
} as const;
